import {DateTime} from 'luxon'
import {NextRouter, useRouter} from 'next/router'
import {useCallback, useEffect, useState} from 'react'

type PushParams = Parameters<NextRouter['push']>
export type PushOptions = {url: PushParams['0']; options: PushParams['2']}

export const usePreventNav = ({
  preventNav,
  onPrevented,
  onResume,
  timeoutMs
}: {
  preventNav: boolean
  onPrevented?: (push: PushOptions) => void
  onResume?: (push: PushOptions) => void
  timeoutMs?: number
}) => {
  const router = useRouter()
  const [navPrevented, setNavPrevented] = useState<{push: PushOptions; ts: string}>()
  const routeChangeStart = useCallback(
    (url: PushParams['0'], options: PushParams['2']) => {
      if (preventNav && !options?.shallow && navPrevented == null) {
        const prevented = {push: {url, options}, ts: DateTime.now().toISO()!}
        setNavPrevented(prevented)
        onPrevented?.(prevented.push)
        throw 'usePreventNav cancelled route change'
      }
    },
    [preventNav, navPrevented]
  )

  useEffect(() => {
    if (navPrevented && !preventNav) {
      setNavPrevented(undefined)
      onResume?.(navPrevented.push)
    }
  }, [navPrevented, preventNav])

  useEffect(() => {
    router.events.on('routeChangeStart', routeChangeStart)
    return () => {
      router.events.off('routeChangeStart', routeChangeStart)
    }
  }, [routeChangeStart])
}
